import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import MuiDialogActions from '@mui/material/DialogActions';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

const StyledCloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  right: '8px',
  top: 0,
  color: theme.palette.grey[500],
}));

const DialogTitle = (props) => {
  const { children, onClose, align, ...other } = props;
  return (
    <MuiDialogTitle sx={{ padding: '8px 16px', margin: 0 }} {...other}>
      <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: align === 'center' ? 'center' : 'space-between' }}>
        <Typography variant="h6" align={align}>
          {children}
        </Typography>
        {onClose ? (
          <StyledCloseButton aria-label="close" onClick={onClose} size="small">
            <CloseIcon />
          </StyledCloseButton>
        ) : null}
      </Box>
    </MuiDialogTitle>
  );
};

const DialogContent = styled(MuiDialogContent)({
  padding: '16px',
});

const DialogActions = styled(MuiDialogActions)({
  margin: 0,
  padding: '8px',
});

function AxlDialog({ isOpen, childrenTitle, childrenAction, children, handleClose, maxWidth = 'md', alignTitle = 'inherit', DialogContentProps }) {
  return (
    <Dialog onClose={handleClose} open={isOpen} fullWidth maxWidth={maxWidth}>
      <DialogTitle onClose={handleClose} align={alignTitle}>
        {childrenTitle}
      </DialogTitle>
      <DialogContent dividers {...DialogContentProps}>
        {children}
      </DialogContent>
      {childrenAction && <DialogActions>{childrenAction}</DialogActions>}
    </Dialog>
  );
}

export default AxlDialog;
